<div (click)="expandOrCollapse()" class="panel-flat-header" style="cursor: pointer;">
    <panel-chevron [showBody]="showBody"></panel-chevron>
    <h3>Company Property Characteristics Overrides</h3>
</div>
@if (showBody && !initialGet && !addingDescriptor) {
    <div class="card-body">
        @if (hasWritePermission) {
            <property-characteristics-picker (descriptorsSelected)="descriptorsSelected($event)"
                                             [descriptorsToExclude]="[]"
                                             [disabled]="addingDescriptor"
                                             [entityId]="companyId"
                                             [isForCompanyOverrides]="true"
                                             entityName="company"
                                             style="display: inline-block; width: 400px;">
            </property-characteristics-picker>
        }
        <table class="table table-striped table-hover descriptor-overrides">
            <tr>
                <th>Category</th>
                <th>Characteristic Name</th>
                <th>Company Usage</th>
                <th>Site Usage</th>
                <th>Parcel Usage</th>
                <th [hidden]="hideComplianceFeatures">Asset Usage</th>
                <th class="text-center">Comments</th>
                <th></th>
            </tr>
            <tbody>
                @for (descriptorOverride of descriptorOverrides; track descriptorOverride; let i = $index) {
                    <tr (mouseenter)="descriptorOverride.isHovered = true"
                        (mouseleave)="descriptorOverride.isHovered = false">
                        <td>
                            {{ descriptorOverride.categoryName }}
                        </td>
                        <td>
                            {{ descriptorOverride.descriptorName }}
                        </td>
                        <td>
                            @if (!isEditMode(descriptorOverride)) {
                                <span [ngClass]="{'red': isOverridden(descriptorOverride, 'companyUsageId')}">
                                    {{ getDescriptorUsage(descriptorOverride.descriptorOverride.companyUsageId) }}
                                </span>
                            }
                            @if (isEditMode(descriptorOverride)) {
                                <select [(ngModel)]="descriptorOverrideToEdit.descriptorOverride.companyUsageId"
                                        class="form-select form-select-sm"
                                        style="width: auto;">
                                    @for (usage of usages; track usage) {
                                        <option [ngValue]="usage.descriptorUsageID">{{ usage.name }}</option>
                                    }
                                </select>
                            }
                        </td>
                        <td>
                            @if (!isEditMode(descriptorOverride)) {
                                <span [ngClass]="{'red': isOverridden(descriptorOverride, 'siteUsageID')}">
                                    {{ getDescriptorUsage(descriptorOverride.descriptorOverride.siteUsageID) }}
                                </span>
                            }
                            @if (isEditMode(descriptorOverride)) {
                                <select [(ngModel)]="descriptorOverrideToEdit.descriptorOverride.siteUsageID"
                                        class="form-select form-select-sm"
                                        style="width: auto;">
                                    @for (usage of usages; track usage) {
                                        <option [ngValue]="usage.descriptorUsageID">{{ usage.name }}</option>
                                    }
                                </select>
                            }
                        </td>
                        <td>
                            @if (!isEditMode(descriptorOverride)) {
                                <span [ngClass]="{'red': isOverridden(descriptorOverride, 'parcelUsageID')}">
                                    {{ getDescriptorUsage(descriptorOverride.descriptorOverride.parcelUsageID) }}
                                </span>
                            }
                            @if (isEditMode(descriptorOverride)) {
                                <select [(ngModel)]="descriptorOverrideToEdit.descriptorOverride.parcelUsageID"
                                        class="form-select form-select-sm"
                                        style="width: auto;">
                                    @for (usage of usages; track usage) {
                                        <option [ngValue]="usage.descriptorUsageID">{{ usage.name }}</option>
                                    }
                                </select>
                            }
                        </td>
                        <td [hidden]="hideComplianceFeatures">
                            <div style="display: flex">
                                @if (!isEditMode(descriptorOverride)) {
                                    <span [ngClass]="{'red': isOverridden(descriptorOverride, 'assetUsageID')}">
                                        {{ getAssetDescriptorUsage(descriptorOverride.descriptorOverride.assetUsageID) }}
                                    </span>
                                }
                                @if (isEditMode(descriptorOverride)) {
                                    <select [(ngModel)]="descriptorOverrideToEdit.descriptorOverride.assetUsageID"
                                            class="form-select form-select-sm"
                                            style="width: auto;">
                                        @for (
                                            usage of getAssetUsages(descriptorOverride.canAssetUsageBeRemoved); track usage) {
                                            <option [ngValue]="usage.descriptorUsageID">{{ usage.name }}</option>
                                        }
                                    </select>
                                }
                                <div [class.invisible]="!isLoadingAssetUsage[descriptorOverride.descriptorDTO.descriptorID]"
                                     style="margin-left: 10px;">
                                    <ws-ace-loader [inline]="true"></ws-ace-loader>
                                </div>
                            </div>
                        </td>
                        <td class="text-center">
                            @if (descriptorOverride.descriptorDTO.notes) {
                                <i [popover]="descriptorOverride.descriptorDTO.notes"
                                   class="fa fa-commenting"
                                   triggers="mouseenter:mouseleave"></i>
                            }
                        </td>
                        <td style="white-space: nowrap;">
                            <div class="crud-buttons">
                                @if (isEditMode(descriptorOverride)) {
                                    <div>
                                        <button (click)="saveDescriptorOverride(i)"
                                                [disabled]="serverActionSingle[i]"
                                                class="ace-btn has-icon btn-primary"
                                                type="button">
                                            <i class="fa fa-save"></i>
                                        </button>
                                        <button (click)="cancelEdit()" [disabled]="serverActionSingle[i]" class="ace-btn has-icon btn-primary btn-danger"
                                                style="margin-left: 5px;"
                                                type="button">
                                            <i class="fa fa-close"></i>
                                        </button>
                                    </div>
                                }
                                @if (hasWritePermission && !isEditMode(descriptorOverride)) {
                                    <div [class.invisible]="!descriptorOverride.isHovered || descriptorOverrideToEdit">
                                        <button (click)="editDescriptorOverride(descriptorOverride)"
                                                [disabled]="serverActionSingle[i] || isLoadingAssetUsage[descriptorOverride.descriptorDTO.descriptorID]"
                                                class="ace-btn has-icon btn-primary"
                                                type="button">
                                            <i class="fa fa-pencil"></i>
                                        </button>
                                        <button (click)="deleteDescriptorOverride(descriptorOverride, i)"
                                                [disabled]="!descriptorOverride.canAssetUsageBeRemoved || serverActionSingle[i] || isLoadingAssetUsage[descriptorOverride.descriptorDTO.descriptorID]"
                                                class="ace-btn has-icon btn-primary btn-danger"
                                                style="margin-left: 5px;"
                                                type="button">
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    </div>
                                }
                                <div [class.invisible]="!serverActionSingle[i]" style="margin-left: 10px;">
                                    <ws-ace-loader [inline]="true"></ws-ace-loader>
                                </div>
                            </div>
                        </td>
                    </tr>
                }
            </tbody>
        </table>
    </div>
}
@if (initialGet || addingDescriptor) {
    <div class="card-body text-center" style="margin-top: 50px; margin-bottom: 50px;">
        <ws-ace-loader [hasOverlay]="false" [marginTop]="0" [marginBottom]="0"></ws-ace-loader>
    </div>
}
